import { useCallback, useEffect } from 'react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/state';
import { ToggleItemVisibility } from '../ToggleItemVisibility';
import { updateUrl } from '@/utils';
import queryString from 'query-string';

export const RgbPointColorToggle = () => {
  const [blendingOpacity, setBlendingOpacity] = useAtom(state.blendOpacity);
  const setBlendOpacityCombined = useSetAtom(state.blendOpacityCombined);
  const hasRgb = useAtomValue(state.hasRgb);

  // Initialize the blending opacity, since it starts from 255 for all modes
  // RGB deployments require the viewer mode to be initialized to 1
  useEffect(() => {
    if (hasRgb) {
      setBlendOpacityCombined({
        viewer: 1,
        assembly: 255,
        spherical: 255,
      });
    }
  }, [setBlendOpacityCombined, hasRgb]);

  useEffect(() => {
    const query = window.location.search;
    const parsed = queryString.parse(query, { arrayFormat: 'comma' });
    if (parsed.blendingOpacity) {
      const blendindOpacity = JSON.parse(parsed.blendingOpacity.toString());
      setBlendingOpacity(blendindOpacity);
    }
  }, [setBlendingOpacity]);

  const isEnabled = blendingOpacity === 1;

  const toggleIsEnabled = useCallback(() => {
    setBlendingOpacity((current: number) => {
      const opacity = current === 1 ? 255 : 1;
      updateUrl('blendingOpacity', String(opacity));
      return opacity;
    });
  }, [setBlendingOpacity]);

  return (
    <ToggleItemVisibility
      label="RGB Point Color"
      isVisible={isEnabled}
      toggleVisibility={toggleIsEnabled}
      // tooltipTitle='"Press Alt + P"'
    />
  );
};
